import React, {Fragment} from 'react';
import {Col, ProgressBar, Row} from 'react-bootstrap';
import {Glyphicon} from "../GlyphIcon";

//A simple page overlay to display the status of file upload(s).
export function FileUploadOverlay(props) {
    
    const {
        uploadingFiles,
        fileProgress,
        show = true
    } = props;

    const getMessage = () => {
        const {} = props;

        if (uploadingFiles) {

            let totalProgress = 0;
            if (typeof fileProgress == 'number') {
                totalProgress = fileProgress
            } else if (fileProgress?.length > 0) {
                totalProgress = (fileProgress.reduce((acc, value) => {
                    return acc + value;
                }, 0) / (100 * fileProgress.length)) * 100;
            }

            // When we're in the process of uploading files lets show what we know of the progress
            return <Fragment>
                <Row>
                    <Col xs={12}>
                        <span>Uploading {uploadingFiles} file{uploadingFiles != 1 ? "s" : ""}.</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <ProgressBar active variant="success" now={totalProgress || 0}/>
                    </Col>
                </Row>
            </Fragment>;
        } else {
            // If we're not in the process of uploading files give the droppable message.
            return <Row>
                <Col xs={12}>
                    <p>Drag and drop file to upload</p>
                </Col>
            </Row>;
        }
    }
    
    if(!show) {
        return null;
    } 

    return <Fragment>
        <div
            className="sb-fileupload-overlay-background"
        />
        <div
            className="sb-fileupload-overlay-popup"
        >
            <Row>
                <Col xs={6} className="sb-fileupload-left-side-border">
                    <div className="sb-fileupload-overlay-drop-area">
                        <Glyphicon glyph="cloud-upload"/>
                    </div>
                </Col>
                <Col xs={6}>
                    <div className="sb-fileupload-right-side-border">
                        <Row>
                            <Col xs={12}>
                                <h3>Upload Files to StreamBank</h3>
                            </Col>
                        </Row>
                        {getMessage()}
                    </div>
                </Col>
            </Row>
        </div>
    </Fragment>;
}


